import { Component } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { animate, style, transition, trigger } from '@angular/animations';
import { CallerIdService } from '../_services/caller-id.service';
import { StoreService } from '../_services/store.service';
import { Store } from '../_models/store';
import { Router } from '@angular/router';

@Component({
  selector: 'app-call-card',
  templateUrl: './call-card.component.html',
  styleUrls: ['./call-card.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateX(100%)', opacity: 0 }),
        animate('300ms ease-out', style({ transform: 'translateX(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ transform: 'translateX(100%)', opacity: 0 }))
      ])
    ])
  ]
})
export class CallCardComponent {
  incomingCallArray: any[] = [];
  private destroySubject: Subject<void> = new Subject<void>();
  storeSub: Subscription;
  store: Store;
  terminalname: string;
  resetCalls: Subscription;

  constructor(
    private callerIdService: CallerIdService,
    private storeService: StoreService,
    private router: Router
  ) { }

  ngOnInit() {
    this.storeSub = this.storeService.current.pipe(takeUntil(this.destroySubject)).subscribe((store) => {
      if (store) {
        this.store = Object.assign(new Store(), store);
      }
    });

    this.resetCalls = this.storeService.isStoreChange.pipe(takeUntil(this.destroySubject)).subscribe((data: any) => {
      this.incomingCallArray = [];
    });

    this.callerIdService.callSet.pipe(takeUntil(this.destroySubject)).subscribe((result) => {
      if (!result) return;
      const newCalls = result.data;
      if (!Array.isArray(newCalls) || newCalls.length === 0) return;
      this.terminalname = localStorage.getItem('selectedTerminalName');
      if (!this.store) return;

      const isHybrid = !!this.store?.feature_flag?.['HYBRID_CALLER_ID'];
      if ((isHybrid && this.terminalname === result.station) || !isHybrid) {
        this.updateIncomingCalls(newCalls);
      }
    });
  }

  updateIncomingCalls(newCalls: any[]): void {
    if (!Array.isArray(newCalls)) return;

    // Remove calls that are no longer in the incoming list
    this.incomingCallArray = this.incomingCallArray.filter((existingCall) =>
      newCalls.some((newCall) => newCall.call_id === existingCall.call_id)
    );

    // Add new calls to the array
    newCalls.forEach((newCall) => {
      const existingCall = this.incomingCallArray.find((call) => call.call_id === newCall.call_id);

      if (!existingCall) {
        this.incomingCallArray.push(newCall);
      }
    });

  }

  handleIgnore(call: any): void {
    this.incomingCallStatusUpdate(call, 'Missed');
  }

  handleAccept(call: any): void {
    this.incomingCallStatusUpdate(call, 'Answered');
  }

  handleAvoid(call: any): void {
    this.incomingCallStatusUpdate(call, 'Avoided');
  }

  incomingCallStatusUpdate(call: any, status: string): void {
    const payload = {
      callId: call.call_id,
      eventType: status
    };

    this.callerIdService.updateCallStatus(payload).pipe(takeUntil(this.destroySubject)).subscribe(() => {
      const index = this.incomingCallArray.findIndex((n) => n.call_id === call.call_id);
      if (index > -1) {
        setTimeout(() => {
          this.incomingCallArray.splice(index, 1);
        }, 300);
      }

      if (status === 'Answered') {
        const emitCallerId = () => this.callerIdService.setPhoneNumbertoOrderAndDelivery.next(call);
        if (window.location.hash === '#/home/orders') {
          this.callerIdService.acceptIgnreCall.next(true);
          this.callerIdService.setPendingCallerId(call);
          emitCallerId();
        } else {
          this.callerIdService.setPendingCallerId(call);
          this.router.navigate(['/home/orders']).then(emitCallerId);
        }
      }
    });
  }

  trackByCallId(index: number, call: any): string {
    return call.call_id;
  }

  ngOnDestroy() {
    this.destroySubject.next();
    this.destroySubject.complete();
    if (this.storeSub) {
      this.storeSub.unsubscribe();
    }
    if (this.resetCalls) {
      this.resetCalls.unsubscribe();
    }
  }
}
